import { createSlice } from '@reduxjs/toolkit';

//redux slice to controle isOpenMenu
const megaMenuSlice = createSlice({
	name: 'megaMenu',
	initialState: {
		value: {
			isOpenMenu: false,
			selectedFirstLevel: null,
		},
	},
	reducers: {
		setIsOpenMenu: (state, action) => {
			Object.assign(state.value, { isOpenMenu: action.payload });
		},
		setSelectedFirstLevel(state, action) {
			Object.assign(state.value, { selectedFirstLevel: action.payload });
		},
	},
});

export const { setIsOpenMenu, setSelectedFirstLevel } = megaMenuSlice.actions;
export const selectMenuState = (state) => state.megaMenu.value.isOpenMenu;
export const selectFirstLevel = (state) => state.megaMenu.value.selectedFirstLevel;
export default megaMenuSlice.reducer;
